import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from '../../../services/user.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
import { Ipassword } from '../../Interfaces/iuser';

@Component({
  selector: 'app-restorepsw2',
  templateUrl: './restorepsw2.component.html'
})

export class RestorePsw2Component implements OnInit {
  formPswedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  mensaje: string = "";
  msgtype: string = "";
  //key: string = "";

  constructor(
    private formBuilder: FormBuilder, 
    private router: Router,
    private userservice: UserService,
    private _snackBar: MatSnackBar,
  ) {
    this.formPswedit = formBuilder.group({
      psw1: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
      psw2: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]]
    });
  }

  ngOnInit() {
        this.mensaje = "Código aceptado. La contraseña debe tener al menos 6 caracteres de longitud";
        this.msgtype = "msg-notify";
  }

  Save()
  {
    if (this.formPswedit.value.psw1 != this.formPswedit.value.psw2)
      alert("Error en la confirmación de la contraseña");
    else {
      try {
        const ip: Ipassword = {
          id: this.userservice.userID,
          password: this.formPswedit.value.psw1
        };
        this.userservice.PutPasswordV2(ip).subscribe(results => {
          if (results.ok) {
            this.openSB(results.body.response);
            this.router.navigate(["login"]);
          }
          else {
            alert(results.body.response);
          }
        },
          (e) => {
            alert(e.error);
          });
      }
      catch (e) {
        console.log(e.message);
        alert(e.message);
      }
    }
  }

  Cancel()
  {
          this.router.navigate(["login"]);
  }



  hasError(nombreControl: string, validacion: string) {
    const control = this.formPswedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg,'', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


}
